import { useContext, useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { CashierShiftDto } from "../../../../dtos/catalogs/CashierShift/CashierShiftDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupCashRegisterReceipts } from "../../../Shared/NewForms/NFLookupCashRegisterReceipts";
import { NFLookupRetailSettings } from "../../../Shared/NewForms/NFLookupRetailSettings";
import { CashierShiftStatus } from "../../../../dtos/catalogs/CashierShift/CreateCashierShiftDto";
import CashierShiftDetailSkeleton from "./CashierShiftDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import CashierShiftDetailMain from "./CashierShiftDetailMain";

interface IProps {
  model: CashierShiftDto | null;
  modelUpdatedEvent: (newModel: CashierShiftDto) => void;
}

interface CashierShiftModel {
  id: string;
  name: string;
  description?: string;
  uniqueCode?: string;
  createdDate?: Date;
  cashShiftStart: Date;
  cashShiftEnd: Date;
  cashRegisterRetailId?: string;
  status?: number;
}

export const CashierShiftDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<CashierShiftModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("description", model.description);
      setValue("uniqueCode", model.uniqueCode);
      setValue("createdDate", model.createdDate);
      setValue("cashShiftStart", model.cashShiftStart);
      setValue("cashShiftEnd", model.cashShiftEnd);
      setValue("cashRegisterRetailId", model.cashRegisterRetailId);
      setValue("status", model.status);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: CashierShiftModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    if (action === "save") {
      const newModel: CashierShiftModel = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <CashierShiftDetailSkeleton />
      </>
    );
  }

  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <CashierShiftDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
